<template lang="pug">
v-list-item(
  :link="!!link"
)
  v-list-item-avatar(@click="click(link, item)")
    v-icon {{ icon }}

    //- IDÉIA PARA UMA CAIXA DE SELEÇÃO NA LISTA...
    //- v-list-item-avatar(@click="click(iconLink || link, item)")
      //- v-tooltip(bottom)
      //-   template(#activator="{ on, attrs }")
      //-     v-btn(
      //-       v-bind="attrs"
      //-       v-on="on"
      //-     )
      //-       //- :text="isText(iconLink)"
      //-       //- :icon="!isText(iconLink)"
      //-       //- @click="$emit('perform', { link: iconLink })"
      //-       v-hover(v-slot="{ hover }")
      //-         v-icon(v-if="hover && iconLink") mdi-check-box
      //-         v-icon(v-else) {{ icon || iconLinkIcon }}
      //-   //-     v-icon(
      //-   //-       v-if="isIcon(action)"
      //-   //-       :color="color(action)"
      //-   //-       :left="isText(action)"
      //-   //-     )
      //-   //-       | {{ iconLinkIcon || icon }}
      //-   span
      //-     span.text-md.font-weight-medium {{ iconLink.title || iconLink.verb || iconLink.name }}
      //-     br
      //-     span.font-weight-light {{ iconLink.description }}

  v-list-item-content(@click="click(link, item)")
    v-list-item-title {{ title }}
    v-list-item-subtitle.text--primary {{ subtitle }}
    v-list-item-subtitle {{ description }}

  v-list-item-action
    v-row

      //- Ações agrupáveis
      v-menu(
        v-for="(category, index) in pins.categories"
        :key="`menu-${category}`"
        offset-y
      )
        template(#activator="{ on, attrs }")
          v-btn(
            v-bind="attrs"
            v-on="on"
            text
            rounded
          )
            v-icon mdi-menu-down
            | {{ category }}
        v-list
          action-bar-menu-item(
            v-for="(action,index) in pins.links.filter(x => x.category === category)"
            :key="`menu-${category}-${index}`"
            :action="action"
            @perform="opts => $emit('perform', opts)"
          )

      //- Ações não agrupáveis
      action-bar-pin(
        v-for="(action,index) in pins.links.filter(x => !x.category)"
        :key="`pin-${index}`"
        :action="action"
        @perform="opts => $emit('perform', opts)"
      )

      //- MENU DE AÇÕES
      //-
      v-menu(
        v-if="actions.length"
        bottom left offset-y
      )
        template(#activator="{ on, attrs }")
          v-btn.ml-1(
            icon
            v-bind="attrs"
            v-on="on"
          )
            v-icon mdi-dots-vertical

        v-list
          //- Ações não agrupáveis
          action-bar-menu-item(
            v-for="(action,index) in acts.links.filter(x => !x.category)"
            :key="`menu-${index}`"
            :action="action"
            @perform="opts => $emit('perform', opts)"
          )

          //- Ações agrupáveis
          template(v-for="(category, index) in acts.categories")
            v-subheader {{ category }}

            action-bar-menu-item(
              v-for="(action,index) in acts.links.filter(x => x.category === category)"
              :key="`menu-${category}-${index}`"
              :action="action"
              @perform="opts => $emit('perform', opts)"
            )

</template>

<script>
import { hasRel, findRel, findRels } from '@/helpers/rels'
import ActionBarMenuItem from '@/components/commons/action-bar/ActionBarMenuItem'
import ActionBarPin from '@/components/commons/action-bar/ActionBarPin'
import { computeAll } from '@/helpers/conditions'

export default {
  components: {
    ActionBarMenuItem,
    ActionBarPin,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,

    item: Object, // @type {Keep.Paper.Design.Row}
  },

  data: () => ({
  }),

  computed: {
    row: vm => vm.item['@row'] || {},

    links () {
      const items = this.row.links || []
      computeAll(items, this.context)
      return items.filter(item => !item.hidden)
    },
    link: vm => findRel(vm.links, { exact: 'Primary' }),

    actions: vm => findRels(vm.links, { includes: ['Action'] }),

    acts () {
      const links = [
        ...findRels(this.actions, 'Primary'),
        ...findRels(this.actions, 'Secondary'),
        ...findRels(this.actions, { excludes: [ 'Primary', 'Secondary' ] }),
      ]
      const categories = [ ...new Set( links.filter(x => !!x.category).map(x => x.category) ) ]
      return { categories, links }
    },
    pins () {
      const links = [
        ...findRels(this.actions, { includes: [ 'Pinned' ], excludes: [ 'Primary', 'Secondary' ] }),
        ...findRels(this.actions, { includes: [ 'Pinned', 'Secondary' ]}),
        ...findRels(this.actions, { includes: [ 'Pinned', 'Primary']}),
      ]
      const categories = [ ...new Set( links.filter(x => !!x.category).map(x => x.category) ) ]
      return { categories, links }
    },

    title: vm => vm.get(vm.item,'title'),
    subtitle: vm => vm.get(vm.item, 'subtitle'),
    description: vm => vm.get(vm.item, 'description'),

    icon: vm => vm.get(vm.item, 'icon'),
    iconLinks: vm => vm.cell(vm.item, 'icon').links || [],
    iconLink: vm => findRel(vm.iconLinks, [ 'Primary', 'Action' ]),
    iconLinkIcon: vm => vm.iconLink?.icon,

    context () {
      return { ...this.item }
    },
  },

  methods: {
    get (item, property) {
      return item[property]?.value || item[property]
    },
    cell (item, property) {
      return item[property] ?? {}
    },

    isText(link) {
      return hasRel(link, { include: ['Text'] }) || !!link.icon
    },
    isIcon(link) {
      return !!link.icon
    },

    click (link, item) {
      if (link) {
        this.$emit('perform', { link, selection: [ item ] })
      }
    },
  },
}
</script>